import { render, staticRenderFns } from "./base-autocomplete.vue?vue&type=template&id=4b9d4412&scoped=true&"
import script from "./base-autocomplete.vue?vue&type=script&lang=js&"
export * from "./base-autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./base-autocomplete.vue?vue&type=style&index=0&id=4b9d4412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d4412",
  null
  
)

export default component.exports